// extracted by mini-css-extract-plugin
export default {"departments":"jF-z","departmentHeading":"kF-z","departmentSection":"lF-z","departmentName":"mF-z","departmentLink":"nF-z","expandIcon":"oF-z"};